import { SMSNumberBlockService } from '@weave/schema-gen-ts/dist/schemas/sms/number-block/v1/number_block_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaNumberBlockV1Service = bindHTTP(SMSNumberBlockService);
export const serviceName = 'number-block-v1' as const;
